import _u from '../util';

export const TOPICS = [
	{
		'userHpId': '2',
		'name': 'CARDIOLOGISTS',
		'topics':
			[
				{ "id": "5000359", "name": "Acute Coronary Syndrome", "type": "1", "fromDb": false },
				{ "id": "1920", "name": "Atherosclerosis", "type": "1", "fromDb": false },
				{ "id": "390", "name": "Atrial Fibrillation", "type": "1", "fromDb": false },
				{ "id": "6000091", "name": "Cardiovascular Imaging", "type": "1", "fromDb": false },
				{ "id": "477", "name": "Cerebrovascular Accident (CVA)", "type": "1", "fromDb": false },
				{ "id": "64977", "name": "Coronary Artery Disease (CAD)", "type": "1", "fromDb": false },
				{ "id": "64646", "name": "Heart Failure (HF)", "type": "1", "fromDb": false },
				{ "id": "5000629", "name": "Interventional Cardiology", "type": "1", "fromDb": false },
				{ "id": "5000182", "name": "Lipids Management", "type": "1", "fromDb": false },
				{ "id": "419", "name": "Peripheral Artery Disease", "type": "1", "fromDb": false },
				{ "id": "417", "name": "Pulmonary Arterial Hypertension (PAH)", "type": "1", "fromDb": false },
				{ "id": "1069", "name": "Type 2 Diabetes Mellitus", "type": "1", "fromDb": false }
			],
		'show_more_button': 'https://www.' + _u.getDomain(true) + 'medscape.com/public/myalert/cardiology',
	},
	{
		'userHpId': '3',
		'name': 'INFECTIOUS DISEASE SPECIALISTS',
		'topics':
			[
				{ "id": "3029390", "name": "Antibiotic Resistance", "type": "1", "fromDb": false },
				{ "id": "3029660", "name": "Antiretroviral Therapy for HIV Infection", "type": "1", "fromDb": false },
				{ "id": "3032053", "name": "Disaster Medicine", "type": "1", "fromDb": false },
				{ "id": "5001787", "name": "Ebola Virus", "type": "1", "fromDb": false },
				{ "id": "3029479", "name": "Ethics", "type": "1", "fromDb": false },
				{ "id": "3032538", "name": "Hepatitis B Virus (HBV)", "type": "1", "fromDb": false },
				{ "id": "3032539", "name": "Hepatitis C Virus (HCV)", "type": "1", "fromDb": false },
				{ "id": "65348", "name": "HIV Infection", "type": "1", "fromDb": false },
				{ "id": "6001660", "name": "Infection Control", "type": "1", "fromDb": false },
				{ "id": "1226", "name": "Influenza (Flu)", "type": "1", "fromDb": false },
				{ "id": "1195", "name": "Lyme Disease", "type": "1", "fromDb": false },
				{ "id": "3029580", "name": "MRSA", "type": "1", "fromDb": false },
				{ "id": "5003177", "name": "Meningococcal Disease", "type": "1", "fromDb": false },
				{ "id": "6007957", "name": "Microbiome", "type": "1", "fromDb": false },
				{ "id": "6000029", "name": "Pediatric Vaccine", "type": "1", "fromDb": false },
				{ "id": "3032584", "name": "Pneumonia", "type": "1", "fromDb": false },
				{ "id": "3032590", "name": "Sepsis", "type": "1", "fromDb": false },
				{ "id": "1780", "name": "Sexually Transmitted Infections (STI)", "type": "1", "fromDb": false },
				{ "id": "1670", "name": "Sinusitis", "type": "1", "fromDb": false },
				{ "id": "64863", "name": "Tuberculosis", "type": "1", "fromDb": false },
				{ "id": "720", "name": "Urinary Tract Infection (UTI)", "type": "1", "fromDb": false },
				{ "id": "6000030", "name": "Vaccines for Adult", "type": "1", "fromDb": false },
				{ "id": "6007450", "name": "Zika Virus", "type": "1", "fromDb": false },
			],
		'show_more_button': 'https://www.' + _u.getDomain(true) + 'medscape.com/public/myalert/infectious-disease',
	},
	{
		'userHpId': '7',
		'name': 'ONCOLOGISTS',
		'topics':
			[
				{ "id": "846", "name": "Advanced and Metastatic Breast Cancer", "type": "1", "fromDb": false },
				{ "id": "59", "name": "Basal Cell Carcinoma", "type": "1", "fromDb": false },
				{ "id": "821", "name": "Bladder Cancer", "type": "1", "fromDb": false },
				{ "id": "3002702", "name": "Bone Metastasis", "type": "1", "fromDb": false },
				{ "id": "5005278", "name": "Brain Cancer", "type": "1", "fromDb": false },
				{ "id": "840", "name": "Breast Cancer", "type": "1", "fromDb": false },
				{ "id": "3002745", "name": "Cervical Cancer", "type": "1", "fromDb": false },
				{ "id": "3032296", "name": "Colorectal Cancer", "type": "1", "fromDb": false },
				{ "id": "3003432", "name": "Endometrial Cancer", "type": "1", "fromDb": false },
				{ "id": "5000135", "name": "Gastrointestinal Stromal Tumor (GIST)", "type": "1", "fromDb": false },
				{ "id": "1541", "name": "Glioblastoma", "type": "1", "fromDb": false },
				{ "id": "3004984", "name": "Head and Neck Cancer", "type": "1", "fromDb": false },
				{ "id": "3032322", "name": "Hepatocellular Carcinoma (HCC)", "type": "1", "fromDb": false },
				{ "id": "1545", "name": "Hodgkin Lymphoma", "type": "1", "fromDb": false },
				{ "id": "64703", "name": "Leukemia", "type": "1", "fromDb": false },
				{ "id": "5000186", "name": "Lung Cancer", "type": "1", "fromDb": false },
				{ "id": "5000612", "name": "Mantle Cell Lymphoma", "type": "1", "fromDb": false },
				{ "id": "65", "name": "Melanoma", "type": "1", "fromDb": false },
				{ "id": "5003181", "name": "Merkel Cell Carcinoma", "type": "1", "fromDb": false },
				{ "id": "5004022", "name": "Metastatic and Advanced Prostate Cancer", "type": "1", "fromDb": false },
				{ "id": "1166", "name": "Multiple Myeloma", "type": "1", "fromDb": false },
				{ "id": "1557", "name": "Myelodysplastic Syndrome", "type": "1", "fromDb": false },
				{ "id": "3029373", "name": "Mesothelioma", "type": "1", "fromDb": false },
				{ "id": "6000110", "name": "Neuroendocrine Tumor", "type": "1", "fromDb": false },
				{ "id": "1544", "name": "Non-Hodgkin Lymphoma (NHL)", "type": "1", "fromDb": false },
				{ "id": "5005286", "name": "Noncolorectal Gastrointestinal Cancer", "type": "1", "fromDb": false },
				{ "id": "839", "name": "Ovarian Cancer", "type": "1", "fromDb": false },
				{ "id": "669", "name": "Pancreatic Cancer", "type": "1", "fromDb": false },
				{ "id": "3003507", "name": "Primary Bone Cancer", "type": "1", "fromDb": false },
				{ "id": "3003438", "name": "Prostate Cancer", "type": "1", "fromDb": false },
				{ "id": "3005205", "name": "Renal Cell Carcinoma (RCC)", "type": "1", "fromDb": false },
				{ "id": "3029380", "name": "Sarcoma", "type": "1", "fromDb": false },
				{ "id": "56", "name": "Skin Cancer", "type": "1", "fromDb": false },
				{ "id": "3003433", "name": "Testicular Cancer", "type": "1", "fromDb": false },
			],
		'show_more_button': 'https://www.' + _u.getDomain(true) + 'medscape.com/public/myalert/oncology',
	},
	{
		'userHpId': '12',
		'name': 'PSYCHIATRISTS',
		'topics':
			[
				{ "id": "3031959", "name": "ADHD", "type": "1", "fromDb": false },
				{ "id": "3032262", "name": "Addiction", "type": "1", "fromDb": false },
				{ "id": "902", "name": "Alzheimer Disease", "type": "1", "fromDb": false },
				{ "id": "5000473", "name": "Anxiety Disorder", "type": "1", "fromDb": false },
				{ "id": "1942", "name": "Autism", "type": "1", "fromDb": false },
				{ "id": "877", "name": "Bipolar Disorder", "type": "1", "fromDb": false },
				{ "id": "3032028", "name": "Child and Adolescent Psychiatry", "type": "1", "fromDb": false },
				{ "id": "1440", "name": "Depression", "type": "1", "fromDb": false },
				{ "id": "1774", "name": "Eating Disorders", "type": "1", "fromDb": false },
				{ "id": "3032160", "name": "Obsessive-Compulsive Disorder (OCD)", "type": "1", "fromDb": false },
				{ "id": "3032168", "name": "Post-Traumatic Stress Disorder (PTSD)", "type": "1", "fromDb": false },
				{ "id": "876", "name": "Schizophrenia", "type": "1", "fromDb": false },
			],
		'show_more_button': 'https://www.' + _u.getDomain(true) + 'medscape.com/public/myalert/psychiatry',
	},
	{
		'userHpId': '13',
		'name': 'PULMONOLOGISTS',
		'topics':
			[
				{ "id": "64169", "name": "Acute Respiratory Distress Syndrome (ARDS)", "type": "1", "fromDb": false },
				{ "id": "213", "name": "Allergic Rhinitis", "type": "1", "fromDb": false },
				{ "id": "251", "name": "Asthma", "type": "1", "fromDb": false },
				{ "id": "64535", "name": "Bronchoscopy", "type": "1", "fromDb": false },
				{ "id": "708", "name": "Cystic Fibrosis", "type": "1", "fromDb": false },
				{ "id": "260", "name": "COPD", "type": "1", "fromDb": false },
				{ "id": "5004112", "name": "Idiopathic Pulmonary Fibrosis", "type": "1", "fromDb": false },
				{ "id": "1226", "name": "Influenza (Flu)", "type": "1", "fromDb": false },
				{ "id": "266", "name": "Interstitial Lung Disease", "type": "1", "fromDb": false },
				{ "id": "5000186", "name": "Lung Cancer", "type": "1", "fromDb": false },
				{ "id": "3030134", "name": "Mechanical Ventilation", "type": "1", "fromDb": false },
				{ "id": "3030175", "name": "Oxygen Therapy", "type": "1", "fromDb": false },
				{ "id": "3032584", "name": "Pneumonia", "type": "1", "fromDb": false },
				{ "id": "417", "name": "Pulmonary Arterial Hypertension (PAH)", "type": "1", "fromDb": false },
				{ "id": "3032386", "name": "Pulmonary Embolism", "type": "1", "fromDb": false },
				{ "id": "1267", "name": "Sarcoidosis", "type": "1", "fromDb": false },
				{ "id": "6008759", "name": "Severe Asthma", "type": "1", "fromDb": false },
				{ "id": "1344", "name": "Sleep Apnea", "type": "1", "fromDb": false },
				{ "id": "64863", "name": "Tuberculosis", "type": "1", "fromDb": false },
			],
		'show_more_button': 'https://www.' + _u.getDomain(true) + 'medscape.com/public/myalert/pulmonarymedicine',
	},
	{
		'userHpId': '16',
		'name': 'OBSTETRICIANS & GYNECOLOGISTS',
		'topics':
			[
				{ "id": "846", "name": "Advanced and Metastatic Breast Cancer", "type": "1", "fromDb": false },
				{ "id": "840", "name": "Breast Cancer", "type": "1", "fromDb": false },
				{ "id": "3002745", "name": "Cervical Cancer", "type": "1", "fromDb": false },
				{ "id": "3003432", "name": "Endometrial Cancer", "type": "1", "fromDb": false },
				{ "id": "3032465", "name": "Female Infertility", "type": "1", "fromDb": false },
				{ "id": "65348", "name": "HIV Infection", "type": "1", "fromDb": false },
				{ "id": "3029298", "name": "Human Papillomavirus (HPV)", "type": "1", "fromDb": false },
				{ "id": "5000182", "name": "Lipids Management", "type": "1", "fromDb": false },
				{ "id": "1429", "name": "Menopause", "type": "1", "fromDb": false },
				{ "id": "5000191", "name": "Metabolic Syndrome", "type": "1", "fromDb": false },
				{ "id": "3003386", "name": "Nutrition", "type": "1", "fromDb": false },
				{ "id": "185", "name": "Osteoporosis", "type": "1", "fromDb": false },
				{ "id": "839", "name": "Ovarian Cancer", "type": "1", "fromDb": false },
				{ "id": "3032471", "name": "Pregnancy", "type": "1", "fromDb": false },
				{ "id": "1780", "name": "Sexually Transmitted Infection (STI)", "type": "1", "fromDb": false },
				{ "id": "6007450", "name": "Zika Virus", "type": "1", "fromDb": false },
			],
		'show_more_button': 'https://www.' + _u.getDomain(true) + 'medscape.com/public/myalert/obgyn',
	},
	{
		'userHpId': '18',
		'name': 'INTERNISTS',
		'topics':
			[
				{ "id": "3029390", "name": "Antibiotic Resistance", "type": "1", "fromDb": false },
				{ "id": "251", "name": "Asthma", "type": "1", "fromDb": false },
				{ "id": "3029460", "name": "Cardiovascular Risk Management", "type": "1", "fromDb": false },
				{ "id": "3029330", "name": "Geriatrics", "type": "1", "fromDb": false },
				{ "id": "1457", "name": "Headache", "type": "1", "fromDb": false },
				{ "id": "5000498", "name": "Hospital Medicine", "type": "1", "fromDb": false },
				{ "id": "281", "name": "Hypertension", "type": "1", "fromDb": false },
				{ "id": "1226", "name": "Influenza", "type": "1", "fromDb": false },
				{ "id": "5000182", "name": "Lipids Management", "type": "1", "fromDb": false },
				{ "id": "3032356", "name": "Obesity", "type": "1", "fromDb": false },
				{ "id": "3029326", "name": "Palliative Care", "type": "1", "fromDb": false },
				{ "id": "3032210", "name": "Sleep Disorders", "type": "1", "fromDb": false },
				{ "id": "3003382", "name": "Sports Medicine", "type": "1", "fromDb": false },
				{ "id": "1069", "name": "Type 2 Diabetes Mellitus", "type": "1", "fromDb": false },
			],
		'show_more_button': 'https://www.' + _u.getDomain(true) + 'medscape.com/public/myalert/internalmedicine',
	},
	{
		'userHpId': '20',
		'name': 'GASTROENTEROLOGISTS',
		'topics':
			[
				{ "id": "3032290", "name": "Celiac Disease", "type": "1", "fromDb": false },
				{ "id": "3032296", "name": "Colorectal Cancer", "type": "1", "fromDb": false },
				{ "id": "3032531", "name": "Gastroesophageal Reflux Disease", "type": "1", "fromDb": false },
				{ "id": "5000135", "name": "Gastrointestinal Stromal Tumor (GIST)", "type": "1", "fromDb": false },
				{ "id": "3032538", "name": "Hepatitis B Virus (HBV)", "type": "1", "fromDb": false },
				{ "id": "3032539", "name": "Hepatitis C Virus (HCV)", "type": "1", "fromDb": false },
				{ "id": "3032322", "name": "Hepatocellular Carcinoma (HCC)", "type": "1", "fromDb": false },
				{ "id": "3032545", "name": "Inflammatory Bowel Disease (IBD)", "type": "1", "fromDb": false },
				{ "id": "3032548", "name": "Irritable Bowel Syndrome (IBS)", "type": "1", "fromDb": false },
				{ "id": "6007957", "name": "Microbiome", "type": "1", "fromDb": false },
				{ "id": "5005286", "name": "Noncolorectal Gastrointestinal Cancer", "type": "1", "fromDb": false },
				{ "id": "3032581", "name": "Peptic Ulcer Disease", "type": "1", "fromDb": false },
			],
		'show_more_button': 'https://www.' + _u.getDomain(true) + 'medscape.com/public/myalert/gastroenterology',
	},
	{
		'userHpId': '22',
		'name': 'DIABETOLOGISTS & ENDOCRINOLOGISTS',
		'topics':
			[
				{ "id": "1920", "name": "Atherosclerosis", "type": "1", "fromDb": false },
				{ "id": "3032278", "name": "Bariatric Surgery", "type": "1", "fromDb": false },
				{ "id": "3029460", "name": "Cardiovascular Risk Management", "type": "1", "fromDb": false },
				{ "id": "6009753", "name": "Diabetes Research", "type": "1", "fromDb": false },
				{ "id": "5001687", "name": "Diabetic Microvascular Complications", "type": "1", "fromDb": false },
				{ "id": "281", "name": "Hypertension", "type": "1", "fromDb": false },
				{ "id": "1062", "name": "Hypogonadism", "type": "1", "fromDb": false },
				{ "id": "3032465", "name": "Infertility Female", "type": "1", "fromDb": false },
				{ "id": "3032466", "name": "Infertility Male", "type": "1", "fromDb": false },
				{ "id": "5000182", "name": "Lipids Management", "type": "1", "fromDb": false },
				{ "id": "5000188", "name": "Macrovascular Complications of Diabetes", "type": "1", "fromDb": false },
				{ "id": "1429", "name": "Menopause", "type": "1", "fromDb": false },
				{ "id": "5000191", "name": "Metabolic Syndrome", "type": "1", "fromDb": false },
				{ "id": "6000110", "name": "Neuroendocrine Tumor", "type": "1", "fromDb": false },
				{ "id": "3003386", "name": "Nutrition", "type": "1", "fromDb": false },
				{ "id": "3032356", "name": "Obesity", "type": "1", "fromDb": false },
				{ "id": "185", "name": "Osteoporosis", "type": "1", "fromDb": false },
				{ "id": "419", "name": "Peripheral Artery Disease", "type": "1", "fromDb": false },
				{ "id": "3032475", "name": "Reproductive Endocrinology", "type": "1", "fromDb": false },
				{ "id": "1089", "name": "Thyroid Disease", "type": "1", "fromDb": false },
				{ "id": "1068", "name": "Type 1 Diabetes Mellitus", "type": "1", "fromDb": false },
				{ "id": "1069", "name": "Type 2 Diabetes Mellitus", "type": "1", "fromDb": false },
			],
		'show_more_button': 'https://www.' + _u.getDomain(true) + 'medscape.com/public/myalert/diabetes-endocrinology',
	},
	{
		'userHpId': '26',
		'name': 'NEUROLOGISTS',
		'topics':
			[
				{ "id": "902", "name": "Alzheimer Disease", "type": "1", "fromDb": false },
				{ "id": "1942", "name": "Autism", "type": "1", "fromDb": false },
				{ "id": "5005278", "name": "Brain Cancer", "type": "1", "fromDb": false },
				{ "id": "477", "name": "Cerebrovascular Accident (CVA)", "type": "1", "fromDb": false },
				{ "id": "1440", "name": "Depression", "type": "1", "fromDb": false },
				{ "id": "10119", "name": "Epilepsy Notes", "type": "1", "fromDb": false },
				{ "id": "179", "name": "Fibromyalgia", "type": "1", "fromDb": false },
				{ "id": "1541", "name": "Glioblastoma", "type": "1", "fromDb": false },
				{ "id": "1457", "name": "Headache", "type": "1", "fromDb": false },
				{ "id": "923", "name": "Migraine", "type": "1", "fromDb": false },
				{ "id": "3029427", "name": "Mild Cognitive Impairment", "type": "1", "fromDb": false },
				{ "id": "918", "name": "Multiple Sclerosis (MS)", "type": "1", "fromDb": false },
				{ "id": "907", "name": "Parkinson Disease", "type": "1", "fromDb": false },
				{ "id": "3032210", "name": "Sleep Disorders", "type": "1", "fromDb": false },
			],
		'show_more_button': 'https://www.' + _u.getDomain(true) + 'medscape.com/public/myalert/neurology',
	},
	{
		'userHpId': '27',
		'name': 'RHEUMATOLOGISTS',
		'topics':
			[
				{ "id": "179", "name": "Fibromyalgia", "type": "1", "fromDb": false },
				{ "id": "39228", "name": "Gout", "type": "1", "fromDb": false },
				{ "id": "1195", "name": "Lyme Disease", "type": "1", "fromDb": false },
				{ "id": "6007957", "name": "Microbiome", "type": "1", "fromDb": false },
				{ "id": "107", "name": "Osteoarthritis", "type": "1", "fromDb": false },
				{ "id": "185", "name": "Osteoporosis", "type": "1", "fromDb": false },
				{ "id": "31", "name": "Psoriatic Arthritis", "type": "1", "fromDb": false },
				{ "id": "83", "name": "Rheumatoid Arthritis (RA)", "type": "1", "fromDb": false },
				{ "id": "1221", "name": "Systemic Lupus Erythematosus (SLE)", "type": "1", "fromDb": false },
				{ "id": "78", "name": "Sjogren Syndrome", "type": "1", "fromDb": false },
				{ "id": "3005215", "name": "Spondylarthropathy", "type": "1", "fromDb": false },
				{ "id": "118", "name": "Spondylitis, Spondylosis, Kyphosis", "type": "1", "fromDb": false },
			],
		'show_more_button': 'https://www.' + _u.getDomain(true) + 'medscape.com/public/myalert/rheumatology',
	},
	{
		'userHpId': '32',
		'name': 'CRITICAL CARE SPECIALISTS',
		'topics':
			[
				{ "id": "5000359", "name": "Acute Coronary Syndrome", "type": "1", "fromDb": false },
				{ "id": "64169", "name": "Acute Respiratory Distress Syndrome (ARDS)", "type": "1", "fromDb": false },
				{ "id": "480", "name": "Cerebrovascular Accident", "type": "1", "fromDb": false },
				{ "id": "64565", "name": "Coma", "type": "1", "fromDb": false },
				{ "id": "3029424", "name": "Death and Dying", "type": "1", "fromDb": false },
				{ "id": "3032050", "name": "Delirium", "type": "1", "fromDb": false },
				{ "id": "3032307", "name": "ECMO", "type": "1", "fromDb": false },
				{ "id": "3030125", "name": "Endotracheal Intubation", "type": "1", "fromDb": false },
				{ "id": "64646", "name": "Heart Failure (HF)", "type": "1", "fromDb": false },
				{ "id": "3030134", "name": "Mechanical Ventilation", "type": "1", "fromDb": false },
				{ "id": "3032584", "name": "Pneumonia", "type": "1", "fromDb": false },
				{ "id": "3032386", "name": "Pulmonary Embolism", "type": "1", "fromDb": false },
				{ "id": "64449", "name": "Respiratory Failure", "type": "1", "fromDb": false },
				{ "id": "3030209", "name": "Sedation", "type": "1", "fromDb": false },
				{ "id": "5004358", "name": "Seizures", "type": "1", "fromDb": false },
				{ "id": "3032590", "name": "Sepsis", "type": "1", "fromDb": false },
				{ "id": "5004380", "name": "Shock", "type": "1", "fromDb": false },
				{ "id": "3004967", "name": "Telemetry", "type": "1", "fromDb": false },
				{ "id": "3032241", "name": "Traumatic Brain Injury", "type": "1", "fromDb": false },
			],
		'show_more_button': 'https://www.' + _u.getDomain(true) + 'medscape.com/public/myalert/criticalcare',
	},
	{
		'userHpId': '33',
		'name': 'DERMATOLOGISTS',
		'topics':
			[
				{ "id": "38", "name": "Acne", "type": "1", "fromDb": false },
				{ "id": "3029683", "name": "Cosmetic Dermatology", "type": "1", "fromDb": false },
				{ "id": "16", "name": "Atopic Dermatitis", "type": "1", "fromDb": false },
				{ "id": "5004431", "name": "Benign Skin Lesion", "type": "1", "fromDb": false },
				{ "id": "5001239", "name": "Bullous Pemphigoid", "type": "1", "fromDb": false },
				{ "id": "5003770", "name": "Drug-Induced Pemphigus", "type": "1", "fromDb": false },
				{ "id": "5004810", "name": "Toxic Epidermal Necrolysis", "type": "1", "fromDb": false },
				{ "id": "1518", "name": "Cellulitis", "type": "1", "fromDb": false },
				{ "id": "13", "name": "Eczema", "type": "1", "fromDb": false },
				{ "id": "45", "name": "Alopecia", "type": "1", "fromDb": false },
				{ "id": "47", "name": "Hirsutism", "type": "1", "fromDb": false },
				{ "id": "1509", "name": "Urticaria", "type": "1", "fromDb": false },
				{ "id": "5000399", "name": "Hidradenitis Suppurativa", "type": "1", "fromDb": false },
				{ "id": "5002613", "name": "Hyperhidrosis", "type": "1", "fromDb": false },
				{ "id": "65", "name": "Melanoma", "type": "1", "fromDb": false },
				{ "id": "5003181", "name": "Merkel Cell Carcinoma", "type": "1", "fromDb": false },
				{ "id": "3029698", "name": "Pediatric Dermatology", "type": "1", "fromDb": false },
				{ "id": "29", "name": "Psoriasis", "type": "1", "fromDb": false },
				{ "id": "39", "name": "Rosacea", "type": "1", "fromDb": false },
				{ "id": "56", "name": "Skin Cancer", "type": "1", "fromDb": false },
				{ "id": "3029299", "name": "Skin and Soft Tissue Infection", "type": "1", "fromDb": false }
			],
		'show_more_button': 'https://www.' + _u.getDomain(true) + 'medscape.com/public/myalert/dermatology',
	},
	{
		'userHpId': '34',
		'name': 'FAMILY PHYSICIANS',
		'topics':
			[
				{ "id": "5000006", "name": "Adolescent Medicine", "type": "1", "fromDb": false },
				{ "id": "3029390", "name": "Antibiotic Resistance", "type": "1", "fromDb": false },
				{ "id": "251", "name": "Asthma", "type": "1", "fromDb": false },
				{ "id": "3029460", "name": "Cardiovascular Risk Management", "type": "1", "fromDb": false },
				{ "id": "3029330", "name": "Geriatrics", "type": "1", "fromDb": false },
				{ "id": "1457", "name": "Headache", "type": "1", "fromDb": false },
				{ "id": "5000498", "name": "Hospital Medicine", "type": "1", "fromDb": false },
				{ "id": "281", "name": "Hypertension", "type": "1", "fromDb": false },
				{ "id": "1226", "name": "Influenza", "type": "1", "fromDb": false },
				{ "id": "5000182", "name": "Lipids Management", "type": "1", "fromDb": false },
				{ "id": "3032356", "name": "Obesity", "type": "1", "fromDb": false },
				{ "id": "3029326", "name": "Palliative Care", "type": "1", "fromDb": false },
				{ "id": "3032210", "name": "Sleep Disorders", "type": "1", "fromDb": false },
				{ "id": "3003382", "name": "Sports Medicine", "type": "1", "fromDb": false },
				{ "id": "1069", "name": "Type 2 Diabetes Mellitus", "type": "1", "fromDb": false },
				{ "id": "3029313", "name": "Vaccines", "type": "1", "fromDb": false }
			],
		'show_more_button': 'https://www.' + _u.getDomain(true) + 'medscape.com/public/myalert/familymedicine',
	},
	{
		'userHpId': '38',
		'name': 'ALLERGISTS',
		'topics':
			[
				{ "id": "213", "name": "Allergic Rhinitis", "type": "1", "fromDb": false },
				{ "id": "63549", "name": "Anaphylaxis", "type": "1", "fromDb": false },
				{ "id": "5000872", "name": "Angioedema", "type": "1", "fromDb": false },
				{ "id": "251", "name": "Asthma", "type": "1", "fromDb": false },
				{ "id": "16", "name": "Atopic Dermatitis", "type": "1", "fromDb": false },
				{ "id": "5000033", "name": "Biologic Therapy", "type": "1", "fromDb": false },
				{ "id": "3032290", "name": "Celiac Disease", "type": "1", "fromDb": false },
				{ "id": "6002079", "name": "Eosinophilic Esophagitis", "type": "1", "fromDb": false },
				{ "id": "65081", "name": "Food Allergy", "type": "1", "fromDb": false },
				{ "id": "1821", "name": "Immunization", "type": "1", "fromDb": false },
				{ "id": "3032545", "name": "Inflammatory Bowel Disease (IBD)", "type": "1", "fromDb": false },
				{ "id": "6007957", "name": "Microbiome", "type": "1", "fromDb": false },
				{ "id": "3003386", "name": "Nutrition", "type": "1", "fromDb": false },
				{ "id": "6008759", "name": "Severe Asthma", "type": "1", "fromDb": false },
			],
		'show_more_button': 'https://www.' + _u.getDomain(true) + 'medscape.com/public/myalert/allergy-immunology',
	},
	{
		'userHpId': '44',
		'name': 'NEPHROLOGISTS',
		'topics':
			[
				{ "id": "727", "name": "Chronic Kidney Disease (CKD)", "type": "1", "fromDb": false },
				{ "id": "6002498", "name": "Dialysis", "type": "1", "fromDb": false },
				{ "id": "5001687", "name": "Diabetic Microvascular Complications", "type": "1", "fromDb": false },
				{ "id": "281", "name": "Hypertension", "type": "1", "fromDb": false },
				{ "id": "3032066", "name": "End-Stage Renal Disease (ESRD)", "type": "1", "fromDb": false },
				{ "id": "722", "name": "Nephrolithiasis", "type": "1", "fromDb": false },
				{ "id": "3005205", "name": "Renal Cell Carcinoma (RCC)", "type": "1", "fromDb": false },
			],
		'show_more_button': 'https://www.' + _u.getDomain(true) + 'medscape.com/public/myalert/nephrology',
	},
	{
		'userHpId': '50',
		'name': 'INTERNISTS',
		'topics':
			[
				{ "id": "5000359", "name": "Acute Coronary Syndrome", "type": "1", "fromDb": false },
				{ "id": "3029390", "name": "Antibiotic Resistance", "type": "1", "fromDb": false },
				{ "id": "5005247", "name": "Clostridium Difficile Infection", "type": "1", "fromDb": false },
				{ "id": "477", "name": "Cerebrovascular Accident (CVA)", "type": "1", "fromDb": false },
				{ "id": "449", "name": "Deep Venous Thrombosis (DVT)", "type": "1", "fromDb": false },
				{ "id": "3032053", "name": "Disaster Medicine", "type": "1", "fromDb": false },
				{ "id": "64646", "name": "Heart Failure (HF)", "type": "1", "fromDb": false },
				{ "id": "5000498", "name": "Hospital Medicine", "type": "1", "fromDb": false },
				{ "id": "1226", "name": "Influenza", "type": "1", "fromDb": false },
				{ "id": "3030134", "name": "Mechanical Ventilation", "type": "1", "fromDb": false },
				{ "id": "3029580", "name": "MRSA", "type": "1", "fromDb": false },
				{ "id": "3032584", "name": "Pneumonia", "type": "1", "fromDb": false },
				{ "id": "3032386", "name": "Pulmonary Embolism", "type": "1", "fromDb": false },
				{ "id": "3032590", "name": "Sepsis", "type": "1", "fromDb": false },
				{ "id": "3004966", "name": "Physical Trauma", "type": "1", "fromDb": false },
				{ "id": "5000331", "name": "Wound Management", "type": "1", "fromDb": false },
				{ "id": "3032354", "name": "Hospital-Acquired Infection", "type": "1", "fromDb": false },
			],
		'show_more_button': 'https://www.' + _u.getDomain(true) + 'medscape.com/public/myalert/hospitalmedicine',
	},
	{
		'userHpId': '1',
		'name': 'INFECTIOUS DISEASE SPECIALISTS',
		'topics':
			[
				{ "id": "5000006", "name": "Adolescent Medicine", "type": "1", "fromDb": false },
				{ "id": "3029390", "name": "Antibiotic Resistance", "type": "1", "fromDb": false },
				{ "id": "251", "name": "Asthma", "type": "1", "fromDb": false },
				{ "id": "3029460", "name": "Cardiovascular Risk Management", "type": "1", "fromDb": false },
				{ "id": "3029330", "name": "Geriatrics", "type": "1", "fromDb": false },
				{ "id": "1457", "name": "Headache", "type": "1", "fromDb": false },
				{ "id": "5000498", "name": "Hospital Medicine", "type": "1", "fromDb": false },
				{ "id": "281", "name": "Hypertension", "type": "1", "fromDb": false },
				{ "id": "1226", "name": "Influenza", "type": "1", "fromDb": false },
				{ "id": "5000182", "name": "Lipids Management", "type": "1", "fromDb": false },
				{ "id": "3032356", "name": "Obesity", "type": "1", "fromDb": false },
				{ "id": "3029326", "name": "Palliative Care", "type": "1", "fromDb": false },
				{ "id": "3032210", "name": "Sleep Disorders", "type": "1", "fromDb": false },
				{ "id": "3003382", "name": "Sports Medicine", "type": "1", "fromDb": false },
				{ "id": "1069", "name": "Type 2 Diabetes Mellitus", "type": "1", "fromDb": false },
				{ "id": "3029313", "name": "Vaccines", "type": "1", "fromDb": false }
			],
		'show_more_button': 'https://www.' + _u.getDomain(true) + 'medscape.com/public/myalert/populartopics',
	},
	{
		'userHpId': '8',
		'name': 'ORTHOPEDIC SURGEONS',
		'topics':
			[
				{ "id": "5000006", "name": "Adolescent Medicine", "type": "1", "fromDb": false },
				{ "id": "3029390", "name": "Antibiotic Resistance", "type": "1", "fromDb": false },
				{ "id": "251", "name": "Asthma", "type": "1", "fromDb": false },
				{ "id": "3029460", "name": "Cardiovascular Risk Management", "type": "1", "fromDb": false },
				{ "id": "3029330", "name": "Geriatrics", "type": "1", "fromDb": false },
				{ "id": "1457", "name": "Headache", "type": "1", "fromDb": false },
				{ "id": "5000498", "name": "Hospital Medicine", "type": "1", "fromDb": false },
				{ "id": "281", "name": "Hypertension", "type": "1", "fromDb": false },
				{ "id": "1226", "name": "Influenza", "type": "1", "fromDb": false },
				{ "id": "5000182", "name": "Lipids Management", "type": "1", "fromDb": false },
				{ "id": "3032356", "name": "Obesity", "type": "1", "fromDb": false },
				{ "id": "3029326", "name": "Palliative Care", "type": "1", "fromDb": false },
				{ "id": "3032210", "name": "Sleep Disorders", "type": "1", "fromDb": false },
				{ "id": "3003382", "name": "Sports Medicine", "type": "1", "fromDb": false },
				{ "id": "1069", "name": "Type 2 Diabetes Mellitus", "type": "1", "fromDb": false },
				{ "id": "3029313", "name": "Vaccines", "type": "1", "fromDb": false }
			],
		'show_more_button': 'https://www.' + _u.getDomain(true) + 'medscape.com/public/myalert/populartopics',
	},
	{
		'userHpId': '9',
		'name': 'PEDIATRICIANS',
		'topics':
			[
				{ "id": "5000006", "name": "Adolescent Medicine", "type": "1", "fromDb": false },
				{ "id": "3029390", "name": "Antibiotic Resistance", "type": "1", "fromDb": false },
				{ "id": "251", "name": "Asthma", "type": "1", "fromDb": false },
				{ "id": "3029460", "name": "Cardiovascular Risk Management", "type": "1", "fromDb": false },
				{ "id": "3029330", "name": "Geriatrics", "type": "1", "fromDb": false },
				{ "id": "1457", "name": "Headache", "type": "1", "fromDb": false },
				{ "id": "5000498", "name": "Hospital Medicine", "type": "1", "fromDb": false },
				{ "id": "281", "name": "Hypertension", "type": "1", "fromDb": false },
				{ "id": "1226", "name": "Influenza", "type": "1", "fromDb": false },
				{ "id": "5000182", "name": "Lipids Management", "type": "1", "fromDb": false },
				{ "id": "3032356", "name": "Obesity", "type": "1", "fromDb": false },
				{ "id": "3029326", "name": "Palliative Care", "type": "1", "fromDb": false },
				{ "id": "3032210", "name": "Sleep Disorders", "type": "1", "fromDb": false },
				{ "id": "3003382", "name": "Sports Medicine", "type": "1", "fromDb": false },
				{ "id": "1069", "name": "Type 2 Diabetes Mellitus", "type": "1", "fromDb": false },
				{ "id": "3029313", "name": "Vaccines", "type": "1", "fromDb": false }
			],
		'show_more_button': 'https://www.' + _u.getDomain(true) + 'medscape.com/public/myalert/populartopics',
	},
	{
		'userHpId': '14',
		'name': 'SURGEONS',
		'topics':
			[
				{ "id": "5000006", "name": "Adolescent Medicine", "type": "1", "fromDb": false },
				{ "id": "3029390", "name": "Antibiotic Resistance", "type": "1", "fromDb": false },
				{ "id": "251", "name": "Asthma", "type": "1", "fromDb": false },
				{ "id": "3029460", "name": "Cardiovascular Risk Management", "type": "1", "fromDb": false },
				{ "id": "3029330", "name": "Geriatrics", "type": "1", "fromDb": false },
				{ "id": "1457", "name": "Headache", "type": "1", "fromDb": false },
				{ "id": "5000498", "name": "Hospital Medicine", "type": "1", "fromDb": false },
				{ "id": "281", "name": "Hypertension", "type": "1", "fromDb": false },
				{ "id": "1226", "name": "Influenza", "type": "1", "fromDb": false },
				{ "id": "5000182", "name": "Lipids Management", "type": "1", "fromDb": false },
				{ "id": "3032356", "name": "Obesity", "type": "1", "fromDb": false },
				{ "id": "3029326", "name": "Palliative Care", "type": "1", "fromDb": false },
				{ "id": "3032210", "name": "Sleep Disorders", "type": "1", "fromDb": false },
				{ "id": "3003382", "name": "Sports Medicine", "type": "1", "fromDb": false },
				{ "id": "1069", "name": "Type 2 Diabetes Mellitus", "type": "1", "fromDb": false },
				{ "id": "3029313", "name": "Vaccines", "type": "1", "fromDb": false }
			],
		'show_more_button': 'https://www.' + _u.getDomain(true) + 'medscape.com/public/myalert/populartopics',
	},
	{
		'userHpId': '15',
		'name': 'UROLOGISTS',
		'topics':
			[
				{ "id": "5000006", "name": "Adolescent Medicine", "type": "1", "fromDb": false },
				{ "id": "3029390", "name": "Antibiotic Resistance", "type": "1", "fromDb": false },
				{ "id": "251", "name": "Asthma", "type": "1", "fromDb": false },
				{ "id": "3029460", "name": "Cardiovascular Risk Management", "type": "1", "fromDb": false },
				{ "id": "3029330", "name": "Geriatrics", "type": "1", "fromDb": false },
				{ "id": "1457", "name": "Headache", "type": "1", "fromDb": false },
				{ "id": "5000498", "name": "Hospital Medicine", "type": "1", "fromDb": false },
				{ "id": "281", "name": "Hypertension", "type": "1", "fromDb": false },
				{ "id": "1226", "name": "Influenza", "type": "1", "fromDb": false },
				{ "id": "5000182", "name": "Lipids Management", "type": "1", "fromDb": false },
				{ "id": "3032356", "name": "Obesity", "type": "1", "fromDb": false },
				{ "id": "3029326", "name": "Palliative Care", "type": "1", "fromDb": false },
				{ "id": "3032210", "name": "Sleep Disorders", "type": "1", "fromDb": false },
				{ "id": "3003382", "name": "Sports Medicine", "type": "1", "fromDb": false },
				{ "id": "1069", "name": "Type 2 Diabetes Mellitus", "type": "1", "fromDb": false },
				{ "id": "3029313", "name": "Vaccines", "type": "1", "fromDb": false }
			],
		'show_more_button': 'https://www.' + _u.getDomain(true) + 'medscape.com/public/myalert/populartopics',
	},
	{
		'userHpId': '17',
		'name': 'PHYSICIANS',
		'topics':
			[
				{ "id": "5000006", "name": "Adolescent Medicine", "type": "1", "fromDb": false },
				{ "id": "3029390", "name": "Antibiotic Resistance", "type": "1", "fromDb": false },
				{ "id": "251", "name": "Asthma", "type": "1", "fromDb": false },
				{ "id": "3029460", "name": "Cardiovascular Risk Management", "type": "1", "fromDb": false },
				{ "id": "3029330", "name": "Geriatrics", "type": "1", "fromDb": false },
				{ "id": "1457", "name": "Headache", "type": "1", "fromDb": false },
				{ "id": "5000498", "name": "Hospital Medicine", "type": "1", "fromDb": false },
				{ "id": "281", "name": "Hypertension", "type": "1", "fromDb": false },
				{ "id": "1226", "name": "Influenza", "type": "1", "fromDb": false },
				{ "id": "5000182", "name": "Lipids Management", "type": "1", "fromDb": false },
				{ "id": "3032356", "name": "Obesity", "type": "1", "fromDb": false },
				{ "id": "3029326", "name": "Palliative Care", "type": "1", "fromDb": false },
				{ "id": "3032210", "name": "Sleep Disorders", "type": "1", "fromDb": false },
				{ "id": "3003382", "name": "Sports Medicine", "type": "1", "fromDb": false },
				{ "id": "1069", "name": "Type 2 Diabetes Mellitus", "type": "1", "fromDb": false },
				{ "id": "3029313", "name": "Vaccines", "type": "1", "fromDb": false }
			],
		'show_more_button': 'https://www.' + _u.getDomain(true) + 'medscape.com/public/myalert/populartopics',
	},
	{
		'userHpId': '35',
		'name': 'RADIOLOGISTS',
		'topics':
			[
				{ "id": "5000006", "name": "Adolescent Medicine", "type": "1", "fromDb": false },
				{ "id": "3029390", "name": "Antibiotic Resistance", "type": "1", "fromDb": false },
				{ "id": "251", "name": "Asthma", "type": "1", "fromDb": false },
				{ "id": "3029460", "name": "Cardiovascular Risk Management", "type": "1", "fromDb": false },
				{ "id": "3029330", "name": "Geriatrics", "type": "1", "fromDb": false },
				{ "id": "1457", "name": "Headache", "type": "1", "fromDb": false },
				{ "id": "5000498", "name": "Hospital Medicine", "type": "1", "fromDb": false },
				{ "id": "281", "name": "Hypertension", "type": "1", "fromDb": false },
				{ "id": "1226", "name": "Influenza", "type": "1", "fromDb": false },
				{ "id": "5000182", "name": "Lipids Management", "type": "1", "fromDb": false },
				{ "id": "3032356", "name": "Obesity", "type": "1", "fromDb": false },
				{ "id": "3029326", "name": "Palliative Care", "type": "1", "fromDb": false },
				{ "id": "3032210", "name": "Sleep Disorders", "type": "1", "fromDb": false },
				{ "id": "3003382", "name": "Sports Medicine", "type": "1", "fromDb": false },
				{ "id": "1069", "name": "Type 2 Diabetes Mellitus", "type": "1", "fromDb": false },
				{ "id": "3029313", "name": "Vaccines", "type": "1", "fromDb": false }
			],
		'show_more_button': 'https://www.' + _u.getDomain(true) + 'medscape.com/public/myalert/populartopics',
	},
	{
		'userHpId': '36',
		'name': 'OPHTHALMOLOGISTS',
		'topics':
			[
				{ "id": "5000006", "name": "Adolescent Medicine", "type": "1", "fromDb": false },
				{ "id": "3029390", "name": "Antibiotic Resistance", "type": "1", "fromDb": false },
				{ "id": "251", "name": "Asthma", "type": "1", "fromDb": false },
				{ "id": "3029460", "name": "Cardiovascular Risk Management", "type": "1", "fromDb": false },
				{ "id": "3029330", "name": "Geriatrics", "type": "1", "fromDb": false },
				{ "id": "1457", "name": "Headache", "type": "1", "fromDb": false },
				{ "id": "5000498", "name": "Hospital Medicine", "type": "1", "fromDb": false },
				{ "id": "281", "name": "Hypertension", "type": "1", "fromDb": false },
				{ "id": "1226", "name": "Influenza", "type": "1", "fromDb": false },
				{ "id": "5000182", "name": "Lipids Management", "type": "1", "fromDb": false },
				{ "id": "3032356", "name": "Obesity", "type": "1", "fromDb": false },
				{ "id": "3029326", "name": "Palliative Care", "type": "1", "fromDb": false },
				{ "id": "3032210", "name": "Sleep Disorders", "type": "1", "fromDb": false },
				{ "id": "3003382", "name": "Sports Medicine", "type": "1", "fromDb": false },
				{ "id": "1069", "name": "Type 2 Diabetes Mellitus", "type": "1", "fromDb": false },
				{ "id": "3029313", "name": "Vaccines", "type": "1", "fromDb": false }
			],
		'show_more_button': 'https://www.' + _u.getDomain(true) + 'medscape.com/public/myalert/populartopics',
	},
	{
		'userHpId': '42',
		'name': 'PUBLIC HEALTH SPECIALISTS',
		'topics':
			[
				{ "id": "5000006", "name": "Adolescent Medicine", "type": "1", "fromDb": false },
				{ "id": "3029390", "name": "Antibiotic Resistance", "type": "1", "fromDb": false },
				{ "id": "251", "name": "Asthma", "type": "1", "fromDb": false },
				{ "id": "3029460", "name": "Cardiovascular Risk Management", "type": "1", "fromDb": false },
				{ "id": "3029330", "name": "Geriatrics", "type": "1", "fromDb": false },
				{ "id": "1457", "name": "Headache", "type": "1", "fromDb": false },
				{ "id": "5000498", "name": "Hospital Medicine", "type": "1", "fromDb": false },
				{ "id": "281", "name": "Hypertension", "type": "1", "fromDb": false },
				{ "id": "1226", "name": "Influenza", "type": "1", "fromDb": false },
				{ "id": "5000182", "name": "Lipids Management", "type": "1", "fromDb": false },
				{ "id": "3032356", "name": "Obesity", "type": "1", "fromDb": false },
				{ "id": "3029326", "name": "Palliative Care", "type": "1", "fromDb": false },
				{ "id": "3032210", "name": "Sleep Disorders", "type": "1", "fromDb": false },
				{ "id": "3003382", "name": "Sports Medicine", "type": "1", "fromDb": false },
				{ "id": "1069", "name": "Type 2 Diabetes Mellitus", "type": "1", "fromDb": false },
				{ "id": "3029313", "name": "Vaccines", "type": "1", "fromDb": false }
			],
		'show_more_button': 'https://www.' + _u.getDomain(true) + 'medscape.com/public/myalert/populartopics',
	},
	{
		'userHpId': '43',
		'name': 'PATHOLOGISTS',
		'topics':
			[
				{ "id": "5000006", "name": "Adolescent Medicine", "type": "1", "fromDb": false },
				{ "id": "3029390", "name": "Antibiotic Resistance", "type": "1", "fromDb": false },
				{ "id": "251", "name": "Asthma", "type": "1", "fromDb": false },
				{ "id": "3029460", "name": "Cardiovascular Risk Management", "type": "1", "fromDb": false },
				{ "id": "3029330", "name": "Geriatrics", "type": "1", "fromDb": false },
				{ "id": "1457", "name": "Headache", "type": "1", "fromDb": false },
				{ "id": "5000498", "name": "Hospital Medicine", "type": "1", "fromDb": false },
				{ "id": "281", "name": "Hypertension", "type": "1", "fromDb": false },
				{ "id": "1226", "name": "Influenza", "type": "1", "fromDb": false },
				{ "id": "5000182", "name": "Lipids Management", "type": "1", "fromDb": false },
				{ "id": "3032356", "name": "Obesity", "type": "1", "fromDb": false },
				{ "id": "3029326", "name": "Palliative Care", "type": "1", "fromDb": false },
				{ "id": "3032210", "name": "Sleep Disorders", "type": "1", "fromDb": false },
				{ "id": "3003382", "name": "Sports Medicine", "type": "1", "fromDb": false },
				{ "id": "1069", "name": "Type 2 Diabetes Mellitus", "type": "1", "fromDb": false },
				{ "id": "3029313", "name": "Vaccines", "type": "1", "fromDb": false }
			],
		'show_more_button': 'https://www.' + _u.getDomain(true) + 'medscape.com/public/myalert/populartopics',
	},
	{
		'userHpId': '45',
		'name': 'EMERGENCY MEDICINE PHYSICIANS',
		'topics':
			[
				{ "id": "5000006", "name": "Adolescent Medicine", "type": "1", "fromDb": false },
				{ "id": "3029390", "name": "Antibiotic Resistance", "type": "1", "fromDb": false },
				{ "id": "251", "name": "Asthma", "type": "1", "fromDb": false },
				{ "id": "3029460", "name": "Cardiovascular Risk Management", "type": "1", "fromDb": false },
				{ "id": "3029330", "name": "Geriatrics", "type": "1", "fromDb": false },
				{ "id": "1457", "name": "Headache", "type": "1", "fromDb": false },
				{ "id": "5000498", "name": "Hospital Medicine", "type": "1", "fromDb": false },
				{ "id": "281", "name": "Hypertension", "type": "1", "fromDb": false },
				{ "id": "1226", "name": "Influenza", "type": "1", "fromDb": false },
				{ "id": "5000182", "name": "Lipids Management", "type": "1", "fromDb": false },
				{ "id": "3032356", "name": "Obesity", "type": "1", "fromDb": false },
				{ "id": "3029326", "name": "Palliative Care", "type": "1", "fromDb": false },
				{ "id": "3032210", "name": "Sleep Disorders", "type": "1", "fromDb": false },
				{ "id": "3003382", "name": "Sports Medicine", "type": "1", "fromDb": false },
				{ "id": "1069", "name": "Type 2 Diabetes Mellitus", "type": "1", "fromDb": false },
				{ "id": "3029313", "name": "Vaccines", "type": "1", "fromDb": false }
			],
		'show_more_button': 'https://www.' + _u.getDomain(true) + 'medscape.com/public/myalert/populartopics',
	},
	{
		'userHpId': '46',
		'name': 'ANESTHESIOLOGISTS',
		'topics':
			[
				{ "id": "5000006", "name": "Adolescent Medicine", "type": "1", "fromDb": false },
				{ "id": "3029390", "name": "Antibiotic Resistance", "type": "1", "fromDb": false },
				{ "id": "251", "name": "Asthma", "type": "1", "fromDb": false },
				{ "id": "3029460", "name": "Cardiovascular Risk Management", "type": "1", "fromDb": false },
				{ "id": "3029330", "name": "Geriatrics", "type": "1", "fromDb": false },
				{ "id": "1457", "name": "Headache", "type": "1", "fromDb": false },
				{ "id": "5000498", "name": "Hospital Medicine", "type": "1", "fromDb": false },
				{ "id": "281", "name": "Hypertension", "type": "1", "fromDb": false },
				{ "id": "1226", "name": "Influenza", "type": "1", "fromDb": false },
				{ "id": "5000182", "name": "Lipids Management", "type": "1", "fromDb": false },
				{ "id": "3032356", "name": "Obesity", "type": "1", "fromDb": false },
				{ "id": "3029326", "name": "Palliative Care", "type": "1", "fromDb": false },
				{ "id": "3032210", "name": "Sleep Disorders", "type": "1", "fromDb": false },
				{ "id": "3003382", "name": "Sports Medicine", "type": "1", "fromDb": false },
				{ "id": "1069", "name": "Type 2 Diabetes Mellitus", "type": "1", "fromDb": false },
				{ "id": "3029313", "name": "Vaccines", "type": "1", "fromDb": false }
			],
		'show_more_button': 'https://www.' + _u.getDomain(true) + 'medscape.com/public/myalert/populartopics',
	},
	{
		'userHpId': '48',
		'name': 'PLASTIC SURGEONS',
		'topics':
			[
				{ "id": "5000006", "name": "Adolescent Medicine", "type": "1", "fromDb": false },
				{ "id": "3029390", "name": "Antibiotic Resistance", "type": "1", "fromDb": false },
				{ "id": "251", "name": "Asthma", "type": "1", "fromDb": false },
				{ "id": "3029460", "name": "Cardiovascular Risk Management", "type": "1", "fromDb": false },
				{ "id": "3029330", "name": "Geriatrics", "type": "1", "fromDb": false },
				{ "id": "1457", "name": "Headache", "type": "1", "fromDb": false },
				{ "id": "5000498", "name": "Hospital Medicine", "type": "1", "fromDb": false },
				{ "id": "281", "name": "Hypertension", "type": "1", "fromDb": false },
				{ "id": "1226", "name": "Influenza", "type": "1", "fromDb": false },
				{ "id": "5000182", "name": "Lipids Management", "type": "1", "fromDb": false },
				{ "id": "3032356", "name": "Obesity", "type": "1", "fromDb": false },
				{ "id": "3029326", "name": "Palliative Care", "type": "1", "fromDb": false },
				{ "id": "3032210", "name": "Sleep Disorders", "type": "1", "fromDb": false },
				{ "id": "3003382", "name": "Sports Medicine", "type": "1", "fromDb": false },
				{ "id": "1069", "name": "Type 2 Diabetes Mellitus", "type": "1", "fromDb": false },
				{ "id": "3029313", "name": "Vaccines", "type": "1", "fromDb": false }
			],
		'show_more_button': 'https://www.' + _u.getDomain(true) + 'medscape.com/public/myalert/populartopics',
	},
	{
		'userHpId': '25',
		'name': 'MEDICAL STUDENTS',
		'topics':
			[
				{ "id": "5000006", "name": "Adolescent Medicine", "type": "1", "fromDb": false },
				{ "id": "3029390", "name": "Antibiotic Resistance", "type": "1", "fromDb": false },
				{ "id": "251", "name": "Asthma", "type": "1", "fromDb": false },
				{ "id": "3029460", "name": "Cardiovascular Risk Management", "type": "1", "fromDb": false },
				{ "id": "3029330", "name": "Geriatrics", "type": "1", "fromDb": false },
				{ "id": "1457", "name": "Headache", "type": "1", "fromDb": false },
				{ "id": "5000498", "name": "Hospital Medicine", "type": "1", "fromDb": false },
				{ "id": "281", "name": "Hypertension", "type": "1", "fromDb": false },
				{ "id": "1226", "name": "Influenza", "type": "1", "fromDb": false },
				{ "id": "5000182", "name": "Lipids Management", "type": "1", "fromDb": false },
				{ "id": "3032356", "name": "Obesity", "type": "1", "fromDb": false },
				{ "id": "3029326", "name": "Palliative Care", "type": "1", "fromDb": false },
				{ "id": "3032210", "name": "Sleep Disorders", "type": "1", "fromDb": false },
				{ "id": "3003382", "name": "Sports Medicine", "type": "1", "fromDb": false },
				{ "id": "1069", "name": "Type 2 Diabetes Mellitus", "type": "1", "fromDb": false },
				{ "id": "3029313", "name": "Vaccines", "type": "1", "fromDb": false }
			],
		'show_more_button': 'https://www.' + _u.getDomain(true) + 'medscape.com/public/myalert/populartopics',
	},
	{
		'userHpId': '24',
		'name': 'NURSES',
		'topics':
			[
				{ "id": "5000006", "name": "Adolescent Medicine", "type": "1", "fromDb": false },
				{ "id": "3029390", "name": "Antibiotic Resistance", "type": "1", "fromDb": false },
				{ "id": "251", "name": "Asthma", "type": "1", "fromDb": false },
				{ "id": "3029460", "name": "Cardiovascular Risk Management", "type": "1", "fromDb": false },
				{ "id": "3029330", "name": "Geriatrics", "type": "1", "fromDb": false },
				{ "id": "1457", "name": "Headache", "type": "1", "fromDb": false },
				{ "id": "5000498", "name": "Hospital Medicine", "type": "1", "fromDb": false },
				{ "id": "281", "name": "Hypertension", "type": "1", "fromDb": false },
				{ "id": "1226", "name": "Influenza", "type": "1", "fromDb": false },
				{ "id": "5000182", "name": "Lipids Management", "type": "1", "fromDb": false },
				{ "id": "3032356", "name": "Obesity", "type": "1", "fromDb": false },
				{ "id": "3029326", "name": "Palliative Care", "type": "1", "fromDb": false },
				{ "id": "3032210", "name": "Sleep Disorders", "type": "1", "fromDb": false },
				{ "id": "3003382", "name": "Sports Medicine", "type": "1", "fromDb": false },
				{ "id": "1069", "name": "Type 2 Diabetes Mellitus", "type": "1", "fromDb": false },
				{ "id": "3029313", "name": "Vaccines", "type": "1", "fromDb": false }
			],
		'show_more_button': 'https://www.' + _u.getDomain(true) + 'medscape.com/public/myalert/populartopics',
	},
	{
		'userHpId': '30',
		'name': 'PHARMACISTS',
		'topics':
			[
				{ "id": "5000006", "name": "Adolescent Medicine", "type": "1", "fromDb": false },
				{ "id": "3029390", "name": "Antibiotic Resistance", "type": "1", "fromDb": false },
				{ "id": "251", "name": "Asthma", "type": "1", "fromDb": false },
				{ "id": "3029460", "name": "Cardiovascular Risk Management", "type": "1", "fromDb": false },
				{ "id": "3029330", "name": "Geriatrics", "type": "1", "fromDb": false },
				{ "id": "1457", "name": "Headache", "type": "1", "fromDb": false },
				{ "id": "5000498", "name": "Hospital Medicine", "type": "1", "fromDb": false },
				{ "id": "281", "name": "Hypertension", "type": "1", "fromDb": false },
				{ "id": "1226", "name": "Influenza", "type": "1", "fromDb": false },
				{ "id": "5000182", "name": "Lipids Management", "type": "1", "fromDb": false },
				{ "id": "3032356", "name": "Obesity", "type": "1", "fromDb": false },
				{ "id": "3029326", "name": "Palliative Care", "type": "1", "fromDb": false },
				{ "id": "3032210", "name": "Sleep Disorders", "type": "1", "fromDb": false },
				{ "id": "3003382", "name": "Sports Medicine", "type": "1", "fromDb": false },
				{ "id": "1069", "name": "Type 2 Diabetes Mellitus", "type": "1", "fromDb": false },
				{ "id": "3029313", "name": "Vaccines", "type": "1", "fromDb": false }
			],
		'show_more_button': 'https://www.' + _u.getDomain(true) + 'medscape.com/public/myalert/populartopics',
	},
]